import { newCategorySlice } from "./categorySlice";

const { actions } = newCategorySlice;

export const list = payload => dispatch => {
  return dispatch(actions.categoryList(payload));
};
